import { pipe } from 'fp-ts/function';
import * as t from 'io-ts';
import * as E from 'fp-ts/Either';
export function PrefixedString(prefix) {
    return t.brand(t.string, function (s) { return s.startsWith(prefix); }, 'PrefixedString');
}
export function stringFromPrefixedString(prefix) {
    return new t.Type(t.string.name, t.string.is, function (u, c) {
        return pipe(PrefixedString(prefix).validate(u, c), E.chain(function (str) { return t.success(str.slice(str.length)); }));
    }, function (o) { return "".concat(prefix).concat(o); });
}
